'use strict';

/* globals define, ajaxify, $, socket, app, utils, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/fill-blanks-game/game-editor', [
	config.relative_path + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js',
	config.relative_path + '/plugins/nodebb-plugin-invite-to-group/public/vendor/multiselect/jquery.multi-select.js',
	'translator',
	'benchpress',
	'fillBlanksGameCreator',
	'coverPhoto',
	'pictureCropper',
	'slugify',
	'bootbox',
], function (vue, multiselect, translator, Benchpress, fillBlanksGameCreator, coverPhoto, pictureCropper, slugify, bootbox) {
	var	GameEditor = {};

	GameEditor.init = function () {
		fillBlanksGameCreator.init(ajaxify.data.game, ajaxify.data.translations);

		addActions();
		addMultiSelect();
	};

	function addMultiSelect() {
		$('#game-groups').multiSelect({
			selectableHeader: 'All groups',
			selectionHeader: 'Game groups',
		});
	}

	function addActions() {
		var actions = {
			update: updateGame,
			publish: publishGame,
			delete: deleteGame,
		};

		for (var key in actions) {
			if (actions.hasOwnProperty(key)) {
				$('[data-action="' + key + '"]').click(actions[key]);
			}
		}
	}

	function updateGame() {
		save('plugins.fillBlanksGame.updateGame');
	}

	function publishGame() {
		save('plugins.fillBlanksGame.publishGame');
	}

	function save(saveUrl) {
		applyFormValues();

		var data = $.extend({}, ajaxify.data.game, { words: getParsedWords() });

		socket.emit(saveUrl, data, function (err) {
			if (err) {
				return app.alertError(err.message);
			}

			app.alert({
				alert_id: 'game_edited',
				message: '[[fill-blanks:game-edited]]',
				type: 'success',
				timeout: 2000,
			});

			ajaxify.go('groups/' + ajaxify.data.group.slug + '/games/fill-blanks-game/' + ajaxify.data.game.gameId + '/' + slugify(ajaxify.data.game.name));
		});
	}

	function getParsedWords() {
		var words = [];

		for (var wordIndex = 0; wordIndex < ajaxify.data.game.words.length; wordIndex++) {
			var word = ajaxify.data.game.words[wordIndex];

			words.push({
				question: word.question,
				word: word.word,
				mode: word.mode,
				lettersToHide: word.lettersToHide,
				lettersToHideCount: word.lettersToHideCount
			});
		}

		return words;
	}

	function applyFormValues() {
		ajaxify.data.game.description = $('#description').val();
		ajaxify.data.game.name = $('#name').val();
		ajaxify.data.game.isVisible = $('#isVisible').is(':checked');
		ajaxify.data.game.groups = $('#game-groups').val();
	}

	function deleteGame() {
		bootbox.confirm('[[fill-blanks:game-removed]]', function (confirm) {
			if (!confirm) {
				return;
			}

			var data = $.extend({}, ajaxify.data.game, { words: [] });

			socket.emit('plugins.fillBlanksGame.removeGame', data, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alert({
					alert_id: 'game_removed',
					message: '[[fill-blanks:game-removed]]',
					type: 'success',
					timeout: 2000,
				});

				ajaxify.go('groups/' + ajaxify.data.group.slug + '/games/fill-blanks-game');
			});
		});
	}

	return GameEditor;
});
